export function getMissingTemplateKeys(placement, templateData) {
  const missingTemplateKeys =
    placement?.templateKeys?.filter?.((templateKey) => !templateData[templateKey]) ?? [];

  return missingTemplateKeys;
}
